import { render, staticRenderFns } from "./ScbDataTable.vue?vue&type=template&id=54588cf2&scoped=true"
import script from "./ScbDataTable.vue?vue&type=script&lang=js"
export * from "./ScbDataTable.vue?vue&type=script&lang=js"
import style0 from "./ScbDataTable.vue?vue&type=style&index=0&id=54588cf2&prod&scoped=true&lang=css"
import style1 from "./ScbDataTable.vue?vue&type=style&index=1&id=54588cf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54588cf2",
  null
  
)

export default component.exports